import React from "react";
import SEO from '../../seo/SEO'
import Banner from "../../Pages/Banner/Banner";
import YourTrustedHealth from "../../Pages/YourTrustedHealth/YourTrustedHealth";
import ProductSlider from "../../Pages/ProductSlider/ProductSlider";
import TrustedbyWellness from "../../Pages/TrustedbyWellness/TrustedbyWellness";
import Process from "../../Pages/Process/Process";
import Fromcustomformulations from "../../Pages/Fromcustomformulations/Fromcustomformulations";
import PartnerWithNutralike from "../../Pages/PartnerWithNutralike/PartnerWithNutralike";
import ProductSection from "../../Pages/ProductSection/ProductSection";
import SmartPackaging from "../../Pages/SmartPackaging/SmartPackaging.jsx";
import Accreditation from "../../Pages/Accreditation/Accreditation.jsx";
import Testemonial from "../../Pages/Testemonial/Testemonial.jsx";
import CorporateVideo from "../../Pages/CorporateVideo/CorporateVideo.jsx";
import GetInTouch from "../../Pages/GetInTouch/GetInTouch.jsx";
// import HomeProductsShowcase from "../../Pages/HomeProductsShowcase/HomeProductsShowcase.jsx";



const Home = () => {
  return (
    <>
      <SEO />
      <div>
        <Banner />
        <YourTrustedHealth />
        <ProductSection/>
        <TrustedbyWellness />
        {/* <HomeProductsShowcase /> */}
        <Process />
        <Fromcustomformulations />
        <PartnerWithNutralike />
        <SmartPackaging/>
        <Accreditation/>
        <Testemonial/>
        <CorporateVideo/>
        <GetInTouch/>
      </div>
    </>
  );
};

export default Home;